import './js/filmApi';
import './js/refs';
import './js/header_my_library';
import './js/dark_light';
import './js/filmCardMarkUpHome';
import './js/filmCardMarkUpLibrary';
import './js/watchedList';
import './js/queueList';
import './js/local_storage';
import './js/footer';
import './js/modal';
import './js/modal_team';
import './js/sticky_button';
// import './js/pagination';
